module.exports = __webpack_public_path__ + "img/morning_page.19946d51.jpg";